import { render } from "./LabBookSession.vue?vue&type=template&id=4dfc70c9&scoped=true"
import script from "./LabBookSession.vue?vue&type=script&lang=js"
export * from "./LabBookSession.vue?vue&type=script&lang=js"

import "./LabBookSession.vue?vue&type=style&index=0&id=4dfc70c9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfc70c9"]])

export default __exports__